import axios from 'utils/axios';

export default class AiService {
    async getSummaryData(assetId: string): Promise<string> {
        try {
            const result = await axios.get<string>(`/GetSummaryData?assetId=${encodeURIComponent(assetId)}`, {
                headers: {
                    Accept: 'text/html'
                },
                responseType: 'text'
            });
            return result.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch summary data');
        }
    }
}
